function getSliderSettings() {
  return {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-btn--next",
      prevEl: ".swiper-btn--prev",
    },
  };
}

let main = document.querySelector("main");
let pageHeader = document.querySelector("header");

let mainSection = document.querySelector("main section");

if (mainSection) {
  if (mainSection.id.includes("lookbook")) {
    main.classList.add("page-lookbook");
  } else if (mainSection.id.includes("about")) {
    main.classList.add("page-about");
  }

  setTimeout(() => {
    if (
      mainSection.id.includes("pages") ||
      mainSection.className.includes("product-section") ||
      document.body.className.includes("template-page")
    ) {
      if (
        mainSection.id.includes("about") ||
        mainSection.id.includes("lookbook") ||
        mainSection.classList.contains("slideshow-section") ||
        mainSection.classList.contains("section-banner-with-text")
      ) return;

      main.classList.remove("header_overlay");
      pageHeader.classList.remove("overlay");
      pageHeader.classList.remove("header-color-background-5");
      pageHeader.classList.remove("theme-dark");
    }
  });
}

function getSubSliderProductSettings() {
  return {
    slidesPerView: 3,
    direction: "vertical",
    navigation: false,
  };
}

function updatethumbnail() {
  let productList = document.querySelector(".product__media-list");
  let mediaHeight = productList && productList.offsetHeight;
  let mediaThumbHeight = document.querySelector(".product__media-sublist");
  if (mediaThumbHeight) {
    if (window.innerWidth > 1200) {
      mediaThumbHeight.style.height = mediaHeight + "px";
    }
    if (window.innerWidth < 1200) {
      mediaThumbHeight.style.height = 100 + "%";
    }
  }
}

const sliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".product-section .js-media-list") &&
    document.querySelectorAll(".product-section .js-media-list").length > 0
  ) {
    let slider = new Swiper(".js-media-list", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-btn--next",
        prevEl: ".swiper-btn--prev",
      },
      thumbs: {
        swiper: document.querySelector(".js-media-sublist").swiper,
      },
      on: {
        slideChangeTransitionStart: function () {
          document
            .querySelector(".js-media-sublist")
            .swiper.slideTo(
              document.querySelector(".js-media-list").swiper.activeIndex
            );
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            this.slides[this.activeIndex]
              .querySelector(".shopify-model-viewer-ui__button--poster")
              .removeAttribute("hidden");
          }
        },
        touchStart: function (s, e) {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if (
              !this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });

    if (isUpdate) {
      setTimeout(function () {
        slider.update();
        updatethumbnail();
      }, 50);
    }
  }
};

const subSliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".product-section .js-media-sublist") &&
    document.querySelectorAll(".product-section .js-media-sublist").length > 0
  ) {
    const isThumbnailPositionHorizontal =
      document.querySelector(".js-media-sublist")?.dataset?.thumbnailHorizontal;

    const direction = isThumbnailPositionHorizontal ? "horizontal" : "vertical";

    let subSlider = new Swiper(".js-media-sublist", {
      centeredSlides: direction === "horizontal" ? false : true,
      centeredSlidesBounds: true,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      updateOnWindowResize: true,
      slidesPerView: 3,
      spaceBetween: 4,
      direction: "horizontal",
      navigation: false,
      freeMode: false,
      preloadImages: false,
      allowTouchMove: true,
      lazy: true,
      breakpoints: {
        576: {
          direction: "horizontal",
          slidesPerView: direction === "horizontal" ? 5 : 3,
        },
        1200: {
          direction,
          slidesPerView: direction === "horizontal" ? 5 : 3,
        },
      },
      on: {
        touchEnd: function (s, e) {
          let range = 5;
          let diff = (s.touches.diff = s.isHorizontal()
            ? s.touches.currentX - s.touches.startX
            : s.touches.currentY - s.touches.startY);
          if (diff < range || diff > -range) s.allowClick = true;
        },
      },
      transitionStart: function () {
        document
          .querySelector(".js-media-list")
          .swiper.slideTo(
            document.querySelector(".js-media-sublist").swiper.activeIndex
          );
      },
    });

    if (subSlider.slides.length <= 3) {
      subSlider.params.centeredSlides = false;
      subSlider.update();
    }

    if (isUpdate) {
      setTimeout(function () {
        subSlider.update();
      }, 50);
    }
  }
};

let allSections = document.querySelectorAll("section");

window.addEventListener("resize", () => {
  allSections.forEach((prodSection) => {
    if (prodSection.classList.contains("product-section")) {
      setTimeout(() => {
        updatethumbnail();
      }, 50);
    }
  });
});

document.addEventListener("visibilitychange", function () {
  allSections.forEach((prodSection) => {
    if (prodSection.classList.contains("product-section")) {
      setTimeout(() => {
        updatethumbnail();
      }, 50);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  allSections.forEach((prodSection) => {
    if (prodSection.classList.contains("product-section")) {
      setTimeout(() => {
        updatethumbnail();
      }, 50);
    }
  });
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary?.nextElementSibling?.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    var eventList = ["paste", "input"];

    for (event of eventList) {
      this.input.addEventListener(event, (e) => {
        const numberRegex = /^0*?[1-9]\d*$/;

        if (
          numberRegex.test(e.currentTarget.value) ||
          e.currentTarget.value === ""
        ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = 1;
        }

        this.validateQtyRules();
      });
    }

    this.input.addEventListener("focusout", (e) => {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
      }

      this.validateQtyRules();
    });
  }

  connectedCallback() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.validateQtyRules();
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector('button[name="minus"]');
      if (buttonMinus) buttonMinus.disabled = value <= min;
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector('button[name="plus"]');
      if (buttonPlus) buttonPlus.disabled = value >= max;
    }
  }
}

customElements.define("quantity-input", QuantityInput);

if (!customElements.get("price-per-item")) {
  customElements.define(
    "price-per-item",
    class PricePerItem extends HTMLElement {
      constructor() {
        super();

        this.handleQuantityChange = this.updatePriceDisplay.bind(this);
        this.handleVariantAdd = this.onVariantAdd.bind(this);
        this.handleCartChange = this.onCartChange.bind(this);
      }

      connectedCallback() {
        this.input = document.getElementById(this.dataset.inputId);
        this.priceText = this.querySelector(".price-per-item__text");
        this.priceBreaks = this.parsePriceBreaks();

        if (this.input) {
          ["input", "change", "focusout"].forEach((eventName) => {
            this.input.addEventListener(eventName, this.handleQuantityChange);
          });
        }

        document.addEventListener("variant:add", this.handleVariantAdd);
        document.addEventListener("cart:change", this.handleCartChange);
        document.addEventListener("line-item:change", this.handleCartChange);
        this.updatePriceDisplay();
      }

      disconnectedCallback() {
        if (this.input) {
          ["input", "change", "focusout"].forEach((eventName) => {
            this.input.removeEventListener(
              eventName,
              this.handleQuantityChange
            );
          });
        }

        document.removeEventListener("variant:add", this.handleVariantAdd);
        document.removeEventListener("cart:change", this.handleCartChange);
        document.removeEventListener("line-item:change", this.handleCartChange);
      }

      parsePriceBreaks() {
        const priceBreaks = [];
        const minQuantity = parseInt(this.dataset.minQuantity || "1", 10) || 1;

        if (this.dataset.variantPrice) {
          priceBreaks.push({
            quantity: minQuantity,
            price: this.dataset.variantPrice,
          });
        }

        if (this.dataset.priceBreaks) {
          try {
            const parsedBreaks = JSON.parse(this.dataset.priceBreaks);

            parsedBreaks.forEach((priceBreak) => {
              if (!priceBreak?.quantity || !priceBreak?.price) return;

              priceBreaks.push({
                quantity: parseInt(priceBreak.quantity, 10),
                price: priceBreak.price,
              });
            });
          } catch (error) {
            console.error(error);
          }
        }

        return priceBreaks.sort((a, b) => b.quantity - a.quantity);
      }

      getCurrentQuantity() {
        const minQuantity = parseInt(this.dataset.minQuantity || "1", 10) || 1;
        const inputQuantity =
          parseInt(this.input?.value || "", 10) || minQuantity;

        if (this.dataset.quantityMode === "product") {
          const cartQuantity =
            parseInt(
              this.dataset.cartQuantity ||
                this.input?.dataset.cartQuantity ||
                "0",
              10
            ) || 0;

          return cartQuantity + inputQuantity;
        }

        return inputQuantity;
      }

      getMatchingCartQuantity(cart) {
        const cartItems = cart?.items;

        if (!Array.isArray(cartItems)) return null;

        if (this.dataset.quantityMode === "cart" && this.dataset.lineItemKey) {
          const matchingLineItem = cartItems.find(
            (item) => String(item.key) === String(this.dataset.lineItemKey)
          );

          return matchingLineItem ? Number(matchingLineItem.quantity || 0) : 0;
        }

        const variantId = String(this.dataset.variantId || "");

        return cartItems.reduce((total, item) => {
          const itemVariantId = String(
            item.variant_id ?? item.variantId ?? item.id ?? ""
          );

          if (itemVariantId !== variantId) return total;

          return total + Number(item.quantity || 0);
        }, 0);
      }

      onVariantAdd(event) {
        const closestForm = this.closest("form");
        const eventForm = event.detail?.formElement;

        if (!closestForm || closestForm !== eventForm) return;
        if (
          String(this.dataset.variantId || "") !==
          String(event.detail?.variant?.id || "")
        )
          return;

        const addedQuantity = Number(event.detail?.quantity || 0);
        const nextCartQuantity =
          (parseInt(
            this.dataset.cartQuantity ||
              this.input?.dataset.cartQuantity ||
              "0",
            10
          ) || 0) + addedQuantity;

        this.dataset.cartQuantity = String(nextCartQuantity);

        if (this.input) {
          this.input.dataset.cartQuantity = String(nextCartQuantity);
        }

        this.updatePriceDisplay();
      }

      onCartChange(event) {
        const cart = event.detail?.cart;
        const matchingCartQuantity = this.getMatchingCartQuantity(cart);

        if (matchingCartQuantity === null) return;

        this.dataset.cartQuantity = String(matchingCartQuantity);

        if (this.input && this.dataset.quantityMode === "product") {
          this.input.dataset.cartQuantity = String(matchingCartQuantity);
        }

        if (this.input && this.dataset.quantityMode === "cart") {
          this.input.value = String(matchingCartQuantity);
          this.input.setAttribute("value", String(matchingCartQuantity));
        }

        this.updatePriceDisplay();
      }

      updatePriceDisplay() {
        if (!this.priceText || !this.priceBreaks?.length) return;

        const currentQuantity = this.getCurrentQuantity();
        const activePriceBreak =
          this.priceBreaks.find(
            (priceBreak) => currentQuantity >= priceBreak.quantity
          ) || this.priceBreaks[this.priceBreaks.length - 1];

        if (!activePriceBreak) return;

        this.priceText.textContent = `${this.dataset.atText} ${activePriceBreak.price} / ${this.dataset.eachText}`;
      }
    }
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get("anchored-popover-component")) {
  customElements.define(
    "anchored-popover-component",
    class AnchoredPopoverComponent extends HTMLElement {
      constructor() {
        super();

        this.interactionDelay = 200;
        this.openTimer = null;
        this.closeTimer = null;
        this.supportsAnchor = false;

        try {
          this.supportsAnchor = CSS.supports("position-anchor: --anchor");
        } catch (error) {
          this.supportsAnchor = false;
        }

        this.onTriggerEnter = this.onTriggerEnter.bind(this);
        this.onTriggerLeave = this.onTriggerLeave.bind(this);
        this.onPopoverEnter = this.onPopoverEnter.bind(this);
        this.onPopoverLeave = this.onPopoverLeave.bind(this);
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onBeforeToggle = this.onBeforeToggle.bind(this);
        this.updatePosition = this.updatePosition.bind(this);
        this.resizeListener = debounce(this.onResize.bind(this), 100);
      }

      connectedCallback() {
        this.trigger = this.querySelector("[data-popover-trigger]");
        this.popoverEl = this.querySelector("[data-popover-content]");

        if (!this.trigger || !this.popoverEl) return;

        this.nativePopover =
          typeof this.popoverEl.showPopover === "function" &&
          this.popoverEl.hasAttribute("popover");

        if (this.dataset.hoverTriggered != null) {
          this.trigger.addEventListener("pointerenter", this.onTriggerEnter);
          this.trigger.addEventListener("pointerleave", this.onTriggerLeave);
          this.trigger.addEventListener("focus", this.onTriggerEnter);
          this.trigger.addEventListener("blur", this.onTriggerLeave);
          this.popoverEl.addEventListener("pointerenter", this.onPopoverEnter);
          this.popoverEl.addEventListener("pointerleave", this.onPopoverLeave);
        }

        if (this.nativePopover) {
          this.popoverEl.addEventListener("beforetoggle", this.onBeforeToggle);
        } else {
          // No native popover support: manage open state via a class + click.
          this.trigger.addEventListener("click", this.onTriggerClick);
          document.addEventListener("click", this.onDocumentClick);
        }
      }

      disconnectedCallback() {
        if (this.trigger) {
          this.trigger.removeEventListener("pointerenter", this.onTriggerEnter);
          this.trigger.removeEventListener("pointerleave", this.onTriggerLeave);
          this.trigger.removeEventListener("focus", this.onTriggerEnter);
          this.trigger.removeEventListener("blur", this.onTriggerLeave);
          this.trigger.removeEventListener("click", this.onTriggerClick);
        }

        if (this.popoverEl) {
          this.popoverEl.removeEventListener("pointerenter", this.onPopoverEnter);
          this.popoverEl.removeEventListener("pointerleave", this.onPopoverLeave);
          this.popoverEl.removeEventListener("beforetoggle", this.onBeforeToggle);
        }

        document.removeEventListener("click", this.onDocumentClick);
        window.removeEventListener("resize", this.resizeListener);
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
      }

      onDocumentClick = (event) => {
        if (this.nativePopover || !this.isOpen()) return;
        if (this.contains(event.target)) return;
        this.hide();
      };

      isOpen() {
        if (!this.popoverEl) return false;
        if (this.nativePopover) return this.popoverEl.matches(":popover-open");
        return this.popoverEl.classList.contains("is-open");
      }

      show() {
        if (this.isOpen()) return;
        this.positionPopover();

        if (this.nativePopover) {
          this.popoverEl.showPopover();
        } else {
          this.popoverEl.classList.add("is-open");
        }

        window.addEventListener("resize", this.resizeListener);
        requestAnimationFrame(this.updatePosition);
      }

      hide() {
        if (!this.isOpen()) return;

        if (this.nativePopover) {
          this.popoverEl.hidePopover();
        } else {
          this.popoverEl.classList.remove("is-open");
        }

        window.removeEventListener("resize", this.resizeListener);
      }

      onTriggerClick(event) {
        event.preventDefault();
        this.isOpen() ? this.hide() : this.show();
      }

      onTriggerEnter() {
        clearTimeout(this.closeTimer);
        this.trigger.dataset.hoverActive = "true";

        if (!this.isOpen()) {
          this.openTimer = setTimeout(() => {
            if (this.trigger.dataset.hoverActive === "true") this.show();
          }, this.interactionDelay);
        }
      }

      onTriggerLeave() {
        delete this.trigger.dataset.hoverActive;
        clearTimeout(this.openTimer);

        if (this.isOpen()) {
          this.closeTimer = setTimeout(
            () => this.hide(),
            this.interactionDelay
          );
        }
      }

      onPopoverEnter() {
        clearTimeout(this.closeTimer);
      }

      onPopoverLeave() {
        this.closeTimer = setTimeout(() => this.hide(), this.interactionDelay);
      }

      onBeforeToggle(event) {
        if (event.newState === "open") {
          this.positionPopover();
          window.addEventListener("resize", this.resizeListener);
          requestAnimationFrame(this.updatePosition);
        } else {
          window.removeEventListener("resize", this.resizeListener);
        }
      }

      onResize() {
        if (this.isOpen()) this.hide();
      }

      positionPopover() {
        // Native CSS anchor positioning handles placement automatically.
        if (this.supportsAnchor) return;
        this.updatePosition();
      }

      updatePosition() {
        if (this.supportsAnchor || !this.popoverEl || !this.trigger) return;

        const spacing = 8;
        const rect = this.trigger.getBoundingClientRect();
        const popoverHeight = this.popoverEl.offsetHeight;

        let top = rect.bottom + spacing;

        if (
          popoverHeight &&
          top + popoverHeight > window.innerHeight &&
          rect.top - popoverHeight - spacing > 0
        ) {
          top = rect.top - popoverHeight - spacing;
        }

        this.popoverEl.style.setProperty("--anchor-x", `${rect.left}`);
        this.popoverEl.style.setProperty("--anchor-y", `${top}`);
        this.popoverEl.style.setProperty("--anchor-width", `${rect.width}`);
      }
    }
  );
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
        document.body.classList.add("overflow-hidden");
      }
    });

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("quickview-overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
      document.body.classList.add("quickview-overflow-hidden");
    });
  }
}

customElements.define("modal-opener", ModalOpener);

function setupResponsiveVideoSwitching(video) {
  if (
    !video ||
    video.nodeName !== "VIDEO" ||
    !video.hasAttribute("data-poster-desktop") ||
    video.dataset.responsiveVideoInit
  ) {
    return;
  }
  video.dataset.responsiveVideoInit = "true";

  const desktopQuery = window.matchMedia("(min-width: 750px)");

  const applyPoster = () => {
    const poster = video.getAttribute(
      desktopQuery.matches ? "data-poster-desktop" : "data-poster-mobile"
    );
    if (poster) video.setAttribute("poster", poster);
  };

  applyPoster();

  desktopQuery.addEventListener("change", () => {
    const wasPlaying = !video.paused;
    applyPoster();
    video.load();
    if (wasPlaying || video.autoplay) {
      video.play().catch(() => {});
    }
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);

      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      setupResponsiveVideoSwitching(deferredElement);

      if (
        deferredElement.nodeName === "VIDEO" ||
        deferredElement.nodeName === "IFRAME"
      ) {
        if (this.getAttribute("data-autoplay") !== null) {
          deferredElement.setAttribute("autoplay", "true");
          deferredElement.setAttribute("muted", "true");
          deferredElement
            .play()
            .catch((error) => console.warn("Autoplay prevented:", error));
        }

        if (this.classList.contains("video-section__media")) {
          let playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {}).catch((error) => {});
          }
        }

        const autoplayBehavior = this.getAttribute("data-autoplay-behavior");

        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              let playPromise = entry.target.play();

              if (playPromise !== undefined) {
                playPromise.then(() => {}).catch((error) => {});
              }
            } else {
              entry.target.pause();
            }
          });
        });
        if (autoplayBehavior == "scroll") {
          videoObserver.observe(deferredElement);
        }
      }

      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
              this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    this.sliderItems = this.querySelectorAll(".slider__slide");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    const clickedElement =
      event.target.closest("[data-product-url]") || event.target;
    this.combinedProductURL = clickedElement.dataset?.productUrl || null;

    const combinedProductURL = event.target.dataset?.productUrl;

    this.updateOptions();
    // updateMasterId method updates currentVariant from liquid <script data-all-variations-no-high>
    this.updateMasterId();
    this.toggleAddButton(true, "");

    this.isHighVariantNeedUpdate = false;
    // -----
    // checking for high-variant and combined products
    // if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }
    // -----

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (
        this.currentVariant?.featured_media &&
        this.dataset?.variantMediaDisplay === "show_all"
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        this.updateMedia(mediaId);
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia(mediaId = null) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const targetMediaId =
      mediaId ||
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`;

    const newMediaGlobal = document.querySelector(
      `[data-media-id="${targetMediaId}"]`
    );

    if (!newMediaGlobal) return;

    const parent = newMediaGlobal.parentElement;

    /**
     * ------------------------------------------------
     * Main sliders
     * ------------------------------------------------
     */
    const swiperWrappers = document.querySelectorAll(
      ".product__media-wrapper, .global-variant-slider"
    );

    swiperWrappers.forEach((elem) => {
      // skip quickview here
      if (
        elem.firstElementChild &&
        elem.firstElementChild.classList.contains("quick-product__media-list")
      ) {
        return;
      }

      if (this.isHidden(elem)) return;

      const newMedia = elem.querySelector(`[data-media-id="${targetMediaId}"]`);

      if (!newMedia) return;

      const mediaList = elem.querySelector(
        ".js-media-list, .global-variant-js-media-list"
      );

      /**
       * Swiper layouts
       */
      if (mediaList && mediaList.swiper) {
        let slideIndex = mediaList.swiper.slides.findIndex((slideEl) => {
          return slideEl.dataset?.mediaId === targetMediaId;
        });

        // fallback
        if (slideIndex === -1) {
          slideIndex = Number(newMedia.dataset?.swiperSlideIndex || 0);
        }

        mediaList.swiper.slideTo(slideIndex, 800);
      } else {
        /**
         * Non-swiper layouts
         */
        newMedia && parent.prepend(newMedia);

        window.setTimeout(() => {
          parent.scroll(0, 0);
        });
      }

      /**
       * stacked / stacked_previews support
       */
      const stackedList =
        elem.querySelector(
          ".product__media-list[data-desktop-type='stacked_previews']"
        ) ||
        elem.querySelector(".product__media-list[data-desktop-type='stacked']");

      if (stackedList && window.innerWidth >= 990) {
        const targetItem = stackedList.querySelector(
          `[data-media-id="${targetMediaId}"]`
        );

        if (targetItem) {
          const offset =
            targetItem.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: offset - 100,
            behavior: "smooth",
          });
        }
      }
    });

    /**
     * ------------------------------------------------
     * Quick view
     * ------------------------------------------------
     */
    const swiperWrappersQuickView = document.querySelectorAll(
      ".quick-product__media-list"
    );

    swiperWrappersQuickView.forEach((elem) => {
      if (this.isHidden(elem)) return;

      const newMedia = elem.querySelector(`[data-media-id="${targetMediaId}"]`);

      if (!newMedia) return;

      const mediaList = elem.querySelector(".quick-js-media-list");

      if (mediaList && mediaList.swiper) {
        let slideIndex = mediaList.swiper.slides.findIndex((slideEl) => {
          return slideEl.dataset?.mediaId === targetMediaId;
        });

        if (slideIndex === -1) {
          slideIndex = Number(newMedia.dataset?.swiperSlideIndex || 0);
        }

        mediaList.swiper.slideTo(slideIndex, 800);
      } else {
        newMedia && parent.prepend(newMedia);

        window.setTimeout(() => {
          parent.scroll(0, 0);
        });
      }
    });
  }

  updateURL() {
    if (!this.closest(".quick-add-modal__content-wrapper")) {
      if (this.dataset.updateUrl === "false") return;
      let basePath =
        this.combinedProductURL || this.dataset.url || window.location.pathname;

      if (basePath.includes("?")) {
        basePath = basePath.split("?")[0];
      }

      const newUrl = this.currentVariant
        ? `${basePath}?variant=${this.currentVariant.id}`
        : basePath;

      window.history.replaceState({}, "", newUrl);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant.options[index - 1] === previousOptionSelected
        )
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];

    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;

      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];

      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }

  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    const selectedValues = controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    });

    return selectedValues;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (
                this.currentVariant.featured_media &&
                this.dataset?.variantMediaDisplay === "show_all"
              ) {
                // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
                const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
                this.updateMedia(mediaId);
              }
            }
          } catch (err) {}
        }
        // -----

        this.updateElementsAfterFetch(html);

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  toggleAddButton(disable = true, text) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const addButtonText =
        addButton.querySelector(".button__label") ||
        addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        if (text) {
          addButtonText.textContent = text;

          if (text === window.variantStrings.unavailable) {
            addButton.dataset.status = "unavailable";
          } else {
            addButton.dataset.status = "sold-out";
          }
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
        addButton.dataset.status = "available";
      }
    });
  }

  resetErrorMessage() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  setUnavailable() {
    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(
      `price-sticky-${this.dataset.section}`
    );
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const pickerInventory = document.getElementById(
      `PickerInventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${this.dataset.section}"]`
    );

    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (pickerInventory) pickerInventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-all-variants-no-high]").textContent);
    return this.variantData;
  }

  reinitModalSwiper(modalElement) {
    if (!modalElement) return;

    const swiperContainer = modalElement.querySelector("#product-page-swiper");
    if (!swiperContainer) return;

    // 1. Clean up old Swiper instance on this DOM element if it exists
    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }

    // 2. Re-initialize Swiper with Zoom enabled safely
    if (typeof Swiper !== "undefined") {
      // Build config safely without breaking on undefined Swiper.modules
      const swiperConfig = {
        slidesPerView: 1,
        zoom: {
          maxRatio: 3,
          toggle: true, // Allows double-tap/click to zoom
        },
        navigation: {
          nextEl: modalElement.querySelector(".swiper-button-next-prod-page"),
          prevEl: modalElement.querySelector(".swiper-button-prev-prod-page"),
        },
        pagination: {
          el: modalElement.querySelector(".swiper-pagination-product-page"),
          clickable: true,
        },
      };

      // Only inject modules if your theme setup explicitly uses them globally
      if (Swiper.modules && Swiper.modules.Navigation) {
        swiperConfig.modules = [
          Swiper.modules.Navigation,
          Swiper.modules.Pagination,
          Swiper.modules.Zoom,
        ];
      }

      new Swiper(swiperContainer, swiperConfig);
    }

    // 3. FIX FOR CLOSE BUTTON: Re-register Shopify theme's event listeners
    // Standard Dawn-based themes use setupListeners() or native constructor code
    if (typeof modalElement.setupListeners === "function") {
      modalElement.setupListeners();
    } else {
      // If setupListeners doesn't exist, manually bind the close button fallback
      const closeButton = modalElement.querySelector('[id^="ModalClose-"]');
      if (closeButton) {
        closeButton.addEventListener("click", () => modalElement.hide());
      }
    }
  }

  reinitQuickViewMediaSwipers(mediaDestination) {
    if (!mediaDestination || typeof Swiper === "undefined") return;

    const mainSliderEl = mediaDestination.querySelector(".js-media-list");
    const thumbSliderEl = mediaDestination.querySelector(".js-media-sublist");
    const nextEl = mediaDestination.querySelector(".swiper-btn--next");
    const prevEl = mediaDestination.querySelector(".swiper-btn--prev");

    if (mainSliderEl?.swiper) {
      mainSliderEl.swiper.destroy(true, true);
    }
    if (thumbSliderEl?.swiper) {
      thumbSliderEl.swiper.destroy(true, true);
    }

    let thumbSwiper = null;

    if (thumbSliderEl) {
      const isThumbnailPositionHorizontal =
        thumbSliderEl.dataset?.thumbnailHorizontal;
      const direction = isThumbnailPositionHorizontal
        ? "horizontal"
        : "vertical";

      thumbSwiper = new Swiper(thumbSliderEl, {
        centeredSlides: direction === "horizontal" ? false : true,
        centeredSlidesBounds: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        slidesPerView: 3,
        spaceBetween: 4,
        direction: "horizontal",
        navigation: false,
        freeMode: false,
        preloadImages: false,
        allowTouchMove: true,
        lazy: true,
        breakpoints: {
          576: {
            direction: "horizontal",
            slidesPerView: direction === "horizontal" ? 5 : 3,
          },
          1200: {
            direction,
            slidesPerView: direction === "horizontal" ? 5 : 3,
          },
        },
        on: {
          touchEnd: function (s) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
          transitionStart: function () {
            if (mainSliderEl?.swiper) {
              mainSliderEl.swiper.slideTo(this.activeIndex);
            }
          },
        },
      });

      if (thumbSwiper.slides.length <= 3) {
        thumbSwiper.params.centeredSlides = false;
        thumbSwiper.update();
      }
    }

    if (mainSliderEl) {
      const mainSwiperConfig = {
        slidesPerView: 1,
        navigation: {
          nextEl,
          prevEl,
        },
        on: {
          slideChangeTransitionStart: function () {
            if (thumbSwiper) {
              thumbSwiper.slideTo(this.activeIndex);
            }
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      };

      if (thumbSwiper) {
        mainSwiperConfig.thumbs = {
          swiper: thumbSwiper,
        };
      }

      const mainSwiper = new Swiper(mainSliderEl, mainSwiperConfig);

      window.setTimeout(() => {
        thumbSwiper?.update();
        mainSwiper.update();
      }, 50);
    }
  }

  updateElementsAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    // =================================================================
    // 1. UPDATE BASE URL & CLEAR CACHED STATE OBJECTS
    // =================================================================
    const sourceVariantPicker = html.querySelector(
      "variant-selects, variant-radios"
    );
    if (sourceVariantPicker) {
      if (sourceVariantPicker.dataset.url) {
        this.dataset.url = sourceVariantPicker.dataset.url;
      }
      if (sourceVariantPicker.dataset.isHighVariantProduct) {
        this.dataset.isHighVariantProduct =
          sourceVariantPicker.dataset.isHighVariantProduct;
      }
    }

    // Purge the master array cache so it's forced to look at the new product JSON
    this.variantData = null;

    // =================================================================
    // 2. SYNCHRONIZE HIDDEN VARIANT JSON MARKUP POOLS & FIX VISIBILITY BUG
    // =================================================================
    const sourceScriptNoHigh = html.querySelector(
      "[data-all-variants-no-high]"
    );
    const destScriptNoHigh = this.querySelector("[data-all-variants-no-high]");
    if (sourceScriptNoHigh && destScriptNoHigh) {
      destScriptNoHigh.textContent = sourceScriptNoHigh.textContent;
    }

    const sourceScriptSelected = html.querySelector("[data-selected-variant]");
    const destScriptSelected = this.querySelector("[data-selected-variant]");
    if (sourceScriptSelected && destScriptSelected) {
      destScriptSelected.textContent = sourceScriptSelected.textContent;

      // FIXES THE 'visibility-hidden' BUG:
      // Instantly inject the correct selected variant object into the component state
      try {
        this.currentVariant = JSON.parse(sourceScriptSelected.textContent);
      } catch (e) {
        this.currentVariant = null;
      }
    }

    // =================================================================
    // 3. OVERWRITE INPUT CONTROLS MARKUP COMPLETELY
    // =================================================================
    if (sourceVariantPicker) {
      const sourceFieldsets = sourceVariantPicker.querySelectorAll("fieldset");
      const destFieldsets = this.querySelectorAll("fieldset");

      if (sourceFieldsets.length > 0 && destFieldsets.length > 0) {
        sourceFieldsets.forEach((sourceFieldset, index) => {
          if (destFieldsets[index]) {
            if (
              destFieldsets[index].classList.contains(
                "product-form__controls--dropdown"
              )
            ) {
              destFieldsets[index].removeAttribute("data-initialized");
            }
            destFieldsets[index].innerHTML = sourceFieldset.innerHTML;
            if (sourceFieldset.className)
              destFieldsets[index].className = sourceFieldset.className;
          }
        });
      } else {
        this.innerHTML = sourceVariantPicker.innerHTML;
      }
    }

    // =================================================================
    // 4. RESET MASTER FORM REFERENCE FIELD
    // =================================================================
    const productFormInput = this.closest(".product-section")?.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    const sourceProductFormInput = html.querySelector(
      'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    if (productFormInput && sourceProductFormInput) {
      productFormInput.value = sourceProductFormInput.value;
    }

    // Keep recipient form in sync with the currently selected product.
    const sourceProductForm = html.getElementById(
      `product-form-${sourceSectionId}`
    );
    const destinationProductForm = document.getElementById(
      `product-form-${currentSectionId}`
    );
    if (sourceProductForm && destinationProductForm) {
      const sourceProductFormWrapper =
        sourceProductForm.closest("product-form");
      const destinationProductFormWrapper =
        destinationProductForm.closest("product-form");

      if (sourceProductFormWrapper && destinationProductFormWrapper) {
        const hideErrorsValue =
          sourceProductFormWrapper.getAttribute("data-hide-errors");

        if (hideErrorsValue !== null) {
          destinationProductFormWrapper.setAttribute(
            "data-hide-errors",
            hideErrorsValue
          );
        } else {
          destinationProductFormWrapper.removeAttribute("data-hide-errors");
        }
      }

      const sourceRecipientForm =
        sourceProductForm.querySelector("recipient-form");
      const destinationRecipientForm =
        destinationProductForm.querySelector("recipient-form");

      if (sourceRecipientForm) {
        if (!customElements.get("recipient-form")) {
          const recipientScriptSrc = sourceProductForm
            .querySelector('script[src*="recipient-form.js"]')
            ?.getAttribute("src");
          const scriptAlreadyLoaded = recipientScriptSrc
            ? [...document.scripts].some(
                (script) => script.src === recipientScriptSrc
              )
            : false;

          if (recipientScriptSrc && !scriptAlreadyLoaded) {
            const recipientScript = document.createElement("script");
            recipientScript.src = recipientScriptSrc;
            recipientScript.defer = true;
            document.head.appendChild(recipientScript);
          }
        }

        const nextRecipientForm = sourceRecipientForm.cloneNode(true);
        if (destinationRecipientForm) {
          destinationRecipientForm.replaceWith(nextRecipientForm);
        } else {
          const productFormButtons = destinationProductForm.querySelector(
            ".product-form__buttons"
          );

          if (productFormButtons) {
            productFormButtons.insertAdjacentElement(
              "beforebegin",
              nextRecipientForm
            );
          } else {
            destinationProductForm.appendChild(nextRecipientForm);
          }
        }
      } else if (destinationRecipientForm) {
        destinationRecipientForm.remove();
      }
    }

    const productButtonsSource = html.querySelector(
      `[data-id="ProductButtons-${sourceSectionId}"]`
    );
    const productButtonsDestinationScope =
      this.closest("quick-add-modal, .product-section, .featured-product") ||
      document;
    const productButtonsDestination =
      productButtonsDestinationScope.querySelectorAll(
        `[data-id="ProductButtons-${currentSectionId}"], [data-id="ProductButtons-${sourceSectionId}"]`
      );

    if (productButtonsSource) {
      const sourceButtonsWrapper = productButtonsSource.querySelector(
        ".product-form__buttons"
      );

      productButtonsDestination.forEach((el) => {
        const buttonsWrapper = el.querySelector(".product-form__buttons");

        if (sourceButtonsWrapper && buttonsWrapper) {
          const sourceHasQuantityPricing =
            sourceButtonsWrapper.dataset.hasQuantityPricing === "true";
          const destinationHadQuantityPricing =
            buttonsWrapper.dataset.hasQuantityPricing === "true";

          if (sourceHasQuantityPricing || destinationHadQuantityPricing) {
            if (sourceHasQuantityPricing) {
              buttonsWrapper.dataset.hasQuantityPricing = "true";
            } else {
              buttonsWrapper.removeAttribute("data-has-quantity-pricing");
            }

            const sourceB2bElements = sourceButtonsWrapper.querySelector(
              ".product-b2b-elements"
            );
            const destinationB2bElements = buttonsWrapper.querySelector(
              ".product-b2b-elements"
            );

            if (sourceB2bElements && destinationB2bElements) {
              destinationB2bElements.innerHTML = sourceB2bElements.innerHTML;
            } else if (sourceB2bElements && !destinationB2bElements) {
              buttonsWrapper.insertAdjacentHTML(
                "afterbegin",
                sourceB2bElements.outerHTML
              );
            } else if (!sourceB2bElements && destinationB2bElements) {
              destinationB2bElements.remove();
            }

            const sourceQuantityWrapper = sourceButtonsWrapper.querySelector(
              ".product-form__quantity"
            );
            const destinationQuantityWrapper = buttonsWrapper.querySelector(
              ".product-form__quantity"
            );

            if (sourceQuantityWrapper && destinationQuantityWrapper) {
              if (currentSectionId !== sourceSectionId) {
                destinationQuantityWrapper.innerHTML =
                  sourceQuantityWrapper.innerHTML.replaceAll(
                    sourceSectionId,
                    currentSectionId
                  );
              } else {
                destinationQuantityWrapper.innerHTML =
                  sourceQuantityWrapper.innerHTML;
              }
            }
          }
        }
      });
    }

    // =================================================================
    // FIX FOR PRODUCT HEADLINE/TITLE
    // =================================================================
    const currentContainerContext = this.closest(
      "quick-add-modal, .quick-add-modal, #QuickAdd-Modal, .product-section"
    );

    let titleDestination;
    let titleSource;

    if (currentContainerContext) {
      // Look for the title strictly inside the active container (modal or section)
      titleDestination = currentContainerContext.querySelector(
        ".product__title, .product-single__title, h1"
      );
      titleSource = html.querySelector(
        ".product__title, .product-single__title, h1"
      );
    } else {
      // Fallback fallback to global page search if context isn't matched
      titleDestination = document.querySelector(
        ".product__title, .product-single__title, .product-section h1"
      );
      titleSource = html.querySelector(
        ".product__title, .product-single__title, .product-section h1"
      );
    }

    if (titleSource && titleDestination) {
      titleDestination.innerHTML = titleSource.innerHTML;
    }
    // ================================================================

    // =================================================================
    // FIX FOR PRODUCT DESCRIPTION
    // =================================================================
    const currentModalContext = this.closest(
      "quick-add-modal, .quick-add-modal, #QuickAdd-Modal"
    );

    let descriptionDestination;
    let descriptionSource;

    if (currentModalContext) {
      // If inside a modal, only search within that modal container
      descriptionDestination =
        currentModalContext.querySelector(".card__description");
      descriptionSource = html.querySelector(".card__description");
    } else {
      // Otherwise, fall back to standard page targeting
      descriptionDestination = document.querySelector(".card__description");
      descriptionSource = html.querySelector(".card__description");
    }

    if (descriptionSource && descriptionDestination) {
      descriptionDestination.innerHTML = descriptionSource.innerHTML;
    }
    // =================================================================

    // price
    const priceDestination = document.getElementById(
      `price-${currentSectionId}`
    );
    const priceStickyDestination = document.getElementById(
      `price-sticky-${currentSectionId}`
    );
    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }
    if (priceSource && priceStickyDestination) {
      priceStickyDestination.innerHTML = priceSource.innerHTML;
      const priceText = priceStickyDestination.querySelector(".price-text");
      if (priceText) priceText.className = "price-text";
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = document.getElementById(
      `Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }

    const pickerInventorySource = html.getElementById(
      `PickerInventory-${sourceSectionId}`
    );
    const pickerInventoryDestination = document.getElementById(
      `PickerInventory-${currentSectionId}`
    );
    if (pickerInventorySource && pickerInventoryDestination) {
      pickerInventoryDestination.innerHTML = pickerInventorySource.innerHTML;
      pickerInventoryDestination.classList.toggle(
        "visibility-hidden",
        pickerInventorySource.innerText === ""
      );
    }

    // sku
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = document.getElementById(`Sku-${currentSectionId}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const variantSwatchesSource = html.querySelector(
        `#variant-picker-${sourceSectionId} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = document.querySelector(
        `#variant-picker-${currentSectionId} [data-is-variant-image-swatch="true"]`
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        const quickViewModal = this.closest("quick-add-modal");
        if (quickViewModal) {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML.replaceAll(
              sourceSectionId,
              `quickview-${sourceSectionId}`
            );
        } else {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML;
        }
      }
    }

    // main product media
    // if (
    //   this.dataset?.variantMediaDisplay !== "show_all" ||
    //   this.isCombinedListingsNeedUpdate
    // ) {
    //   const mediaSource = html.querySelector(
    //     `[data-section="product-media-${sourceSectionId}"]`,
    //   );
    //   const mediaDestination = document.querySelector(
    //     `[data-section="product-media-${currentSectionId}"]`,
    //   );
    //   if (mediaSource && mediaDestination) {
    //     mediaDestination.innerHTML = mediaSource.innerHTML;

    //     sliderInit();

    //     const parentQuickView = this.closest("quick-add-modal");
    //     const parentFeaturedProduct = this.closest(".featured-product-section");
    //     if (parentQuickView) {
    //       if (typeof parentQuickView.removeDOMElements === "function") {
    //         parentQuickView.removeDOMElements(mediaDestination);
    //       }
    //       if (typeof parentQuickView.initSlider === "function") {
    //         parentQuickView.initSlider();
    //       }
    //     } else if (parentFeaturedProduct) {
    //       const section = document.getElementById(
    //         `shopify-section-${currentSectionId}`,
    //       );

    //       if (section && typeof window.initFeaturedProduct === "function") {
    //         window.initFeaturedProduct(section);
    //       }
    //     } else {
    //       const section = document.getElementById(
    //         `shopify-section-${currentSectionId}`,
    //       );

    //       if (section && typeof initProductPage === "function") {
    //         initProductPage(section);
    //       }
    //     }
    //   }
    //   const modalSource = html.getElementById(
    //     `ProductModal-${sourceSectionId}`,
    //   );
    //   const modalDestination = document.getElementById(
    //     `ProductModal-${currentSectionId}`,
    //   );

    //   if (modalSource && modalDestination) {
    //     modalDestination.innerHTML = modalSource.innerHTML;

    //     // Re-initializes slider zoom parameters AND fixes destroyed close event listeners
    //     this.reinitModalSwiper(modalDestination);
    //   }
    // }

    // product media
    if (
      this.dataset?.variantMediaDisplay !== "show_all" ||
      this.isCombinedListingsNeedUpdate
    ) {
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = document.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );
      if (mediaSource && mediaDestination) {
        // 1. SAFELY CLEAN UP MEMORY FOR PREVIOUS SWIPER INSTANCES BEFORE OVERWRITING HTML
        const oldMainSwiper =
          mediaDestination.querySelector(".js-media-list")?.swiper;
        const oldSubSwiper =
          mediaDestination.querySelector(".js-media-sublist")?.swiper;

        if (oldMainSwiper) oldMainSwiper.destroy(true, true);
        if (oldSubSwiper) oldSubSwiper.destroy(true, true);

        // 2. DROP IN NEW MARKUP
        mediaDestination.innerHTML = mediaSource.innerHTML;

        const parentQuickView = this.closest("quick-add-modal");
        const parentFeaturedProduct = this.closest(".featured-product-section");
        if (parentQuickView) {
          this.reinitQuickViewMediaSwipers(mediaDestination);
          if (typeof parentQuickView.removeDOMElements === "function") {
            parentQuickView.removeDOMElements(mediaDestination);
          }
          if (typeof parentQuickView.initSlider === "function") {
            parentQuickView.initSlider();
          }
        } else if (parentFeaturedProduct) {
          // Keep existing non-quick-view behavior unchanged.
          if (typeof subSliderInit === "function") {
            subSliderInit(true);
          }
          if (typeof sliderInit === "function") {
            sliderInit(true);
          }
          const section = document.getElementById(
            `shopify-section-${currentSectionId}`
          );

          if (section && typeof window.initFeaturedProduct === "function") {
            window.initFeaturedProduct(section);
          }
        } else {
          // Keep existing non-quick-view behavior unchanged.
          if (typeof subSliderInit === "function") {
            subSliderInit(true);
          }
          if (typeof sliderInit === "function") {
            sliderInit(true);
          }
          const section = document.getElementById(
            `shopify-section-${currentSectionId}`
          );

          if (section && typeof initProductPage === "function") {
            initProductPage(section);
          }
        }
      }

      // Product modal sync (keep this code unchanged below your media code)
      const modalSource = html.getElementById(
        `ProductModal-${sourceSectionId}`
      );
      const modalDestination = document.getElementById(
        `ProductModal-${currentSectionId}`
      );
      if (modalSource && modalDestination) {
        modalDestination.innerHTML = modalSource.innerHTML;
        this.reinitModalSwiper(modalDestination);
      }
    }
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestionation = document.getElementById(
      `variant-picker-${this.dataset.section}`
    );
    if (!variantPickerSource) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestionation.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-picker-${currentSectionId}`
    );

    if (variantPickerSource && variantPickerDestination) {
      const quickViewModal = this.closest("quick-add-modal");
      if (quickViewModal) {
        variantPickerDestination.innerHTML =
          variantPickerSource.innerHTML.replaceAll(
            sourceSectionId,
            `quickview-${sourceSectionId}`
          );
      } else {
        variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
      }
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );

    const $this = this;

    this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
      "click",
      function () {
        if (
          $this
            .closest(".swiper")
            .swiper.slides[
              $this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
        ) {
          if (
            !$this
              .closest(".swiper")
              .swiper.slides[
                $this.closest(".swiper").swiper.activeIndex
              ].querySelector("model-viewer")
              .classList.contains("shopify-model-viewer-ui__disabled")
          ) {
            if (
              $this
                .querySelector(".shopify-model-viewer-ui__button")
                .hasAttribute("hidden")
            ) {
              $this.closest(".swiper").swiper.params.noSwiping = true;
              $this.closest(".swiper").swiper.params.noSwipingClass =
                "swiper-slide";
            }
          }
        }
      }
    );

    this.querySelector(
      ".shopify-model-viewer-ui__controls-overlay"
    ).addEventListener("click", function () {
      if (
        !$this
          .querySelector(".shopify-model-viewer-ui__button")
          .hasAttribute("hidden")
      ) {
        $this.closest(".swiper").swiper.params.noSwiping = false;
      }
    });
  }
}
customElements.define("product-model", ProductModel);
(function () {
  const imageMouseParallax = (options) => {
    options = options || {};
    this.nameSpaces = {
      wrapper: options.wrapper || ".parallax",
      layers: options.layers || ".parallax-layer",
      deep: options.deep || "data-parallax-deep",
    };

    this.init = function () {
      var self = this;
      var parallaxWrappers = document.querySelectorAll(this.nameSpaces.wrapper);

      for (var i = 0; i < parallaxWrappers.length; i++) {
        (function (i) {
          parallaxWrappers[i].addEventListener("mousemove", function (e) {
            var x = e.clientX;
            var y = e.clientY;
            var layers = parallaxWrappers[i].querySelectorAll(
              self.nameSpaces.layers
            );

            for (var j = 0; j < layers.length; j++) {
              (function (j) {
                var deep = layers[j].getAttribute(self.nameSpaces.deep);
                var disallow = layers[j].getAttribute("data-parallax-disallow");
                var itemX = disallow && disallow === "x" ? 0 : x / deep;
                var itemY = disallow && disallow === "y" ? 0 : y / deep;

                if (disallow && disallow === "both") return;
                layers[j].style.transform =
                  "translateX(" + itemX + "%) translateY(" + itemY + "%)";
              })(j);
            }
          });
        })(i);
      }
    };
    this.init();
    return this;
  };

  document.addEventListener("shopify:section:load", imageMouseParallax);

  imageMouseParallax();
})();

/* Light header on dark bg */
(function () {
  let setLightHeader = () => {
    let articleElement = document.querySelector(".article-template");
    let headerArticle = document.querySelector(".article-template__header");
    let headerWrapper = document.querySelector(".header");
    let headerLogo =
      document.querySelector(
        ".header > .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)"
      ) ||
      document.querySelector(
        ".header > .header__heading .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)"
      );
    let headerLogoOverlay = document.querySelector(
      ".header__heading-logo--overlay"
    );

    if (headerLogoOverlay) {
      if (headerLogo) {
        headerLogo.classList.add("hide");
      }
      headerLogoOverlay.classList.add("show");
    } else {
      if (headerLogo) {
        headerLogo.classList.remove("hide");
      }
    }

    if (
      articleElement &&
      articleElement.classList.contains("section-template--overlay")
    ) {
      if (headerWrapper) {
        headerWrapper.classList.add("overlay");
        headerWrapper.classList.add("theme-dark");
        headerWrapper.classList.add("header-color-background-5");
      }
    }

    let heroMedia = document.querySelector(".article-template__hero > .media");

    if (heroMedia) {
      if (heroMedia.classList.contains("article-template__hero-large")) {
        headerArticle.classList.add("article-template__header-large");
      } else {
        headerArticle.classList.remove("article-template__header-large");
      }
    }

    // Checking Interactive section
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    const elementOverlay = sections[0].querySelector(".section--has-overlay");

    sections.forEach((section) => {
      const sectionFirstChild = sections[0].querySelector("div");
      if (
        (sections[0].classList.contains("section--overlay") &&
          sectionFirstChild.classList.contains("color-background-3")) ||
        sectionFirstChild.classList.contains("color-background-4") ||
        elementOverlay
      ) {
        headerWrapper.classList.add("overlay");
        headerWrapper.classList.add("theme-dark");
        headerWrapper.classList.add("header-color-background-5");
        if (headerLogoOverlay) {
          if (headerLogo) {
            headerLogo.classList.add("hide");
          }
          headerLogoOverlay.classList.add("show");
        } else {
          if (headerLogo) {
            headerLogo.classList.remove("hide");
          }
        }
      }
    });
  };

  document.addEventListener("shopify:section:load", function () {
    setLightHeader();
  });

  window.addEventListener("resize", function () {
    setLightHeader();
  });

  setLightHeader();
})();

(function () {
  const selectDropDown = () => {
    // Only target dropdowns that haven't been initialized yet
    const dropdowns = document.querySelectorAll(
      ".product-form__controls--dropdown:not([data-initialized])"
    );

    dropdowns.forEach((container) => {
      const elList = container.querySelector(".dropdown-select ul");
      const elListItems = container.querySelectorAll(".dropdown-select ul li");
      const selectedText = container.querySelector(
        ".dropdown-select .select-label"
      );
      const shadowTop = container.querySelector(".shadow-top");
      const shadowBottom = container.querySelector(".shadow-bottom");

      if (!elList || !selectedText) return;

      container.setAttribute("data-initialized", "true");

      const updateShadows = () => {
        shadowTop?.classList.toggle("show", elList.scrollTop > 0);
        shadowBottom?.classList.toggle(
          "show",
          elList.scrollTop + elList.clientHeight < elList.scrollHeight - 5
        );
      };

      selectedText.addEventListener("click", function (e) {
        e.stopPropagation();
        const isActive = elList.classList.contains("active");

        // Close other open dropdowns
        document
          .querySelectorAll(".dropdown-select ul.active")
          .forEach((openUl) => {
            if (openUl !== elList) openUl.classList.remove("active");
          });

        elList.classList.toggle("active");
        if (elList.classList.contains("active")) updateShadows();
      });

      elListItems.forEach((li) => {
        li.addEventListener("click", function () {
          const input = li.querySelector("input");
          const isNotifyMe = li
            .querySelector(".pills-variant-labels")
            ?.classList.contains("notify_me");

          if ((input && !input.classList.contains("disabled")) || isNotifyMe) {
            const span = selectedText.querySelector("span");
            if (span) {
              span.textContent = li.innerText.trim();
              span.setAttribute("title", li.innerText.trim());
            }
            if (li.dataset.color) {
              selectedText.style.setProperty(
                "--swatch-color",
                li.dataset.color
              );
            }
          }
          elList.classList.remove("active");
        });
      });

      elList.addEventListener("scroll", updateShadows);
    });
  };

  // 1. Initial Load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", selectDropDown);
  } else {
    selectDropDown();
  }

  // 2. Global click to close
  document.addEventListener("click", () => {
    document
      .querySelectorAll(".dropdown-select ul.active")
      .forEach((ul) => ul.classList.remove("active"));
  });

  // 3. Shopify Theme Editor Support
  document.addEventListener("shopify:section:load", selectDropDown);

  // 4. THE FIX: Watch for AJAX/Internal page refreshes
  // This observes the body for any added elements and re-runs the init logic
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        selectDropDown();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// ====================== start position determination-function for logoSlideshow ======================
const events = [
  "shopify:block:deselect",
  "shopify:block:select",
  "shopify:section:reorder",
  "shopify:section:deselect",
  "shopify:section:select",
  "shopify:section:unload",
  "shopify:section:load",
  "shopify:inspector:deactivate",
  "shopify:inspector:activate",
];
(function () {
  let logoSlideshow = () => {
    let allChildNodes = document.body.childNodes;
    let sectionLogoSlideshow = document.querySelector(
      ".logo-slideshow-section"
    );
    let shopifySectionHeader = document.querySelector(
      ".shopify-section-header"
    );
    let sectionAnnouncement = document.querySelector(".section-announcement");
    let fixedSectionLogoSlideshow = document.querySelector(
      ".logo-slideshow .fixed-section"
    );
    let sectionLogoSlideshowI;
    let shopifySectionHeaderI;
    let sectionAnnouncementI;
    for (let i = 0; i < allChildNodes.length; i++) {
      if (allChildNodes[i] == sectionLogoSlideshow) {
        sectionLogoSlideshowI = i;
      } else if (allChildNodes[i] == shopifySectionHeader) {
        shopifySectionHeaderI = i;
      } else if (allChildNodes[i] == sectionAnnouncement) {
        sectionAnnouncementI = i;
      } else {
      }
    }
    let effect = document.querySelector(".scroll-logo");
    // ====================== start position determination-function ======================
    function firstSection() {
      if (
        (sectionLogoSlideshowI < shopifySectionHeaderI &&
          sectionLogoSlideshowI < sectionAnnouncementI) ||
        sectionLogoSlideshowI < shopifySectionHeaderI ||
        sectionLogoSlideshowI < sectionAnnouncementI ||
        sectionLogoSlideshowI <= 5
      ) {
        sectionLogoSlideshow.classList.add("first-logo-slideshow");
        window.addEventListener("scroll", scrollEffect);
        // ====================== start scroll-function ======================
        function scrollEffect() {
          if (effect) {
            let opacityValue = window.scrollY * 0.005;
            effect.style.opacity = 1 - opacityValue;
            if (window.scrollY >= 350) {
              effect.style.display = "none";
            } else {
              effect.style.display = "block";
            }
          }
        }
        // ====================== end scroll-function ======================

        scrollEffect();
      } else {
        sectionLogoSlideshow &&
          sectionLogoSlideshow.classList.remove("first-logo-slideshow");
      }
    }
    // ====================== end position determination-function ======================
    firstSection();
  };

  logoSlideshow();
  events.forEach(function (item) {
    document.addEventListener(item, function () {
      logoSlideshow();
    });
  });
})();

// ====================== end position determination-function for logoSlideshow ======================

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".cart-items-wrapper" },
    { id: "main-cart-footer", selector: ".cart__footer" },
    { id: "main-cart-shipping", selector: ".cart-shipping" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});

// CART REFRESH EVENT END
// -----------------------------------------------------------------------------